import { __ } from '@wordpress/i18n';
import { useState } from '@wordpress/element';
import apiFetch from '@wordpress/api-fetch';

import {
	__experimentalInputControl as InputControl,
	__experimentalGrid as Grid,
	SelectControl,
	Button,
	Snackbar,
} from '@wordpress/components';


const TabGeneral = ( props ) => {
	// General
	const [ activeESP, setActiveESP ] = useState( re_esp_settings.activeESP );
	const [ saving, setSaving ] = useState( false );
	const [ onSaveMessage, setOnSaveMessage ] = useState( '' );
	const [ onErrorMessage, setOnErrorMessage ] = useState( '' );
	const [ loading, setLoading ] = useState( false );
	const [ isConnected, setIsConnected ] = useState( re_esp_settings.apiStatus );
	const [ testStatus, setTestStatus] = useState('not_valid');
	// Beehiiv
	const [ beehiivAPIKey, setBeehiivAPIKey ] = useState( re_esp_settings.beehiiv.apiKey );
	const [ beehiivPublicationID, setBeehiivPublicationID ] = useState( re_esp_settings.beehiiv.publicationID );

	// Campaign Monitor
	const [ campaignmonitorAPIKey, setCampaignMonitorAPIKey ] = useState( re_esp_settings.campaignmonitor.apiKey );
	const [ campaignmonitorClientID, setCampaignMonitorClientID ] = useState( re_esp_settings.campaignmonitor.clientID );
	const [ campaignmonitorListID, setCampaignMonitorListID ] = useState( re_esp_settings.campaignmonitor.listID );
	const [ campaignmonitorSegmentID, setCampaignMonitorSegmentID ] = useState( re_esp_settings.campaignmonitor.segmentID );

	const saveSettings = () => {
		setLoading( true );
		setSaving( true );
	
		const data = {
			activeESP,
			beehiivAPIKey,
			beehiivPublicationID,
			campaignmonitorAPIKey,
			campaignmonitorClientID,
			campaignmonitorListID,
			campaignmonitorSegmentID,
		};
	
		apiFetch( {
			path: '/re/esp/v1/save_settings',
			method: 'POST',
			data,
		} ).then( ( response ) => {
			setOnSaveMessage( response.message );
	
			if ( response.success === true ) {
				setIsConnected( 'connected' );
			}else{
				setIsConnected( 'not_connected' );
			}
	
			setSaving( false );
			setLoading( false );
		} );
	};
	
	
	const disconnectESP = () => {
		setLoading( true );
		setSaving( true );
	
		apiFetch( {
			path: '/re/esp/v1/disconnect_api',
			method: 'POST',
		} ).then( ( response ) => {
			setOnSaveMessage( response.message );
			setSaving( false );
			setLoading( false );
			setIsConnected( 'not_connected' );
			setTestStatus( 'not_valid' );
			setActiveESP( '' );
			emptyFields();
		} );
	};
	
	const emptyFields = () => {
		setBeehiivAPIKey( '' );
		setBeehiivPublicationID( '' );
		setCampaignMonitorAPIKey( '' );
		setCampaignMonitorClientID( '' );
		setCampaignMonitorListID( '' );
		setCampaignMonitorSegmentID( '' );
	};


	const testAPI = () => {
		setLoading( true );
		setSaving( true );

		const settings = {
			activeESP: activeESP,
		};

		if (activeESP === 'beehiiv') {
			settings.beehiivAPIKey = beehiivAPIKey;
			settings.beehiivPublicationID = beehiivPublicationID;
		}
		else if (activeESP === 'campaignmonitor') {
			settings.campaignmonitorAPIKey = campaignmonitorAPIKey;
			settings.campaignmonitorClientID = campaignmonitorClientID;
			settings.campaignmonitorListID = campaignmonitorListID;
			settings.campaignmonitorSegmentID = campaignmonitorSegmentID;
		}

		

		apiFetch({
			path: 're/esp/v1/test_api',
			method: "POST",
			data: settings,
			})
			.then((response) => {

				if (response.success === true) {
					setTestStatus('valid');
					setOnSaveMessage(response.message);
				} else {
					setTestStatus('not_valid');
					setOnErrorMessage(response.message);
				}

				setSaving( false );
				setLoading( false );
			});
	};

	return (

		<Grid columns={ 1 }>
			{ onSaveMessage && (
				<Snackbar
					className="re-esp-snackbar re-esp-snackbar-settings"
					explicitDismiss
					onDismiss={ () => setOnSaveMessage( '' ) }
					status="success"
				>
					{ onSaveMessage }
				</Snackbar>
			) }

			{ onErrorMessage && (
				<Snackbar
					className="re-esp-snackbar re-esp-snackbar-settings-error"
					explicitDismiss
					onDismiss={ () => setOnErrorMessage( '' ) }
					status="success"
				>
					{ onErrorMessage }
				</Snackbar>
			) }
			
			<SelectControl
				label={ __(
					'Select your Active Email Service Provider',
					're-ESP'
				) }
				value={ activeESP }
				options={ [
					{ label: 'Select your ESP', value: '' },
					{ label: 'Beehiiv', value: 'beehiiv' },
					{
						label: 'Campaign Monitor',
						value: 'campaignmonitor',
					},
				] }
				onChange={ ( value ) => {
					setActiveESP( value );
					emptyFields();
				} }
			/>

			{ activeESP === 'beehiiv' && (
				<>
					<InputControl
						type="text"
						value={ beehiivAPIKey }
						label={ __( 'Beehiiv API Key', 're-ESP' ) }
						onChange={ ( value ) =>
							setBeehiivAPIKey( value )
						}
					/>
					<InputControl
						type="text"
						value={ beehiivPublicationID }
						label={ __(
							'Beehiiv Publication ID',
							're-ESP'
						) }
						onChange={ ( value ) =>
							setBeehiivPublicationID( value )
						}
					/>
				</>
			) }

			{ activeESP === 'campaignmonitor' && (
				<>
					<InputControl
						type="text"
						value={ campaignmonitorAPIKey }
						label={ __(
							'Campaign Monitor API Key',
							're-ESP'
						) }
						onChange={ ( value ) =>
							setCampaignMonitorAPIKey( value )
						}
					/>
					<InputControl
						type="text"
						value={ campaignmonitorClientID }
						label={ __(
							'Campaign Monitor Client ID',
							're-ESP'
						) }
						onChange={ ( value ) =>
							setCampaignMonitorClientID( value )
						}
					/>
					<InputControl
						type="text"
						value={ campaignmonitorListID }
						label={ __(
							'Campaign Monitor List ID',
							're-ESP'
						) }
						onChange={ ( value ) =>
							setCampaignMonitorListID( value )
						}
					/>
					<InputControl
						type="text"
						value={ campaignmonitorSegmentID }
						label={ __(
							'Campaign Monitor Segment ID',
							're-ESP'
						) }
						onChange={ ( value ) =>
							setCampaignMonitorSegmentID( value )
						}
					/>
				</>
			) }



	
			<Button
				className="button button-secondary"
				style={ { marginTop: '1em' } }
				onClick={() => testAPI()}
				disabled={
					isConnected === 'connected' ||
					 saving  ||
					 loading ||
					 activeESP === '' ||
					( activeESP === 'beehiiv' && ( beehiivAPIKey === '' || beehiivPublicationID === '' ) ) ||
					( activeESP === 'campaignmonitor' && ( campaignmonitorAPIKey === '' || campaignmonitorClientID === '' ) )
				}
				>
					{ __( 'Test API', 're-ESP' ) }
			</Button>

			<Button
				className="button button-primary re-esp-primary-button"
				style={ { marginTop: '1em' } }
				onClick={ () => saveSettings() }
				isBusy={ loading }
				disabled={
					testStatus === 'not_valid' ||
					isConnected === 'connected' ||
					saving  ||
					loading ||
					activeESP === '' ||
				   ( activeESP === 'beehiiv' && ( beehiivAPIKey === '' || beehiivPublicationID === '' ) ) ||
				   ( activeESP === 'campaignmonitor' && ( campaignmonitorAPIKey === '' || campaignmonitorClientID === '' ) )
				}
			>
				{ __( 'Save', 're-ESP' ) }
			</Button>

			<Button
				onClick={ () => disconnectESP() }
				isBusy={ loading }
				disabled={ saving || loading || isConnected=== 'not_connected' }
				className="button button-secondary"
			>
				{ __( 'Disconnect', 're-ESP' ) }
			</Button>
			

		</Grid>
	)
	
}


export default TabGeneral;